module.exports = __webpack_public_path__ + "img/43.9d6891c6.png";